import { TextField as MaterialUiInput } from '@mui/material'

import { BaseInputProps } from './BaseInput.types'

import './BaseInput.scss'

const BaseInput: React.FC<BaseInputProps> = ({ id, label, type, value, onChange, sx, ...props }): JSX.Element => {
	return (
		<MaterialUiInput
			id={id}
			className='base-input'
			label={label}
			type={type}
			value={value}
			name={id}
			sx={sx}
			onChange={onChange}
			{...props}
		/>
	)
}

export default BaseInput
